import React from "react";
import Img from "gatsby-image";
import styled from "styled-components";
import { FluidImage, SilentAny } from "../utils/types";

export const ProfileImage = ({
  style,
  fluidImage,
  altText,
}: {
  style?: React.CSSProperties;
  fluidImage?: SilentAny; // TODO: swap this for specific type
  altText?: string;
}): JSX.Element => (
  <>
    {fluidImage ? (
      <ProfileImageStyled
        style={{
          ...style,
        }}
        fluid={fluidImage}
        alt={altText}
      />
    ) : (
      <PlaceholderStyled />
    )}
  </>
);
// passing fluid prop to styled component here to stop tsc warning
const ProfileImageStyled = styled(Img)<{ fluid: FluidImage }>`
  width: 5rem;
  height: 5rem;
  min-width: 60px;
  min-height: 60px;
  max-width: 80px;
  max-height: 80px;
  border-radius: ${(props) => props.theme.borderRadius.circle};
  @media (max-width: ${(props) => props.theme.screenSize.m}px) {
    max-width: 70px;
    max-height: 70px;
  }
  @media (max-width: ${(props) => props.theme.screenSize.m}px) {
    max-width: 60px;
    max-height: 60px;
  }
`;
const PlaceholderStyled = styled.div`
  width: 5rem;
  height: 5rem;
  min-width: 70px;
  min-height: 70px;
  max-width: 80px;
  max-height: 80px;
  border-radius: ${(props) => props.theme.borderRadius.circle};
  background: ${(props) => props.theme.colours.lightGrey};
  @media (max-width: ${(props) => props.theme.screenSize.m}px) {
    max-width: 70px;
    max-height: 70px;
  }
  @media (max-width: ${(props) => props.theme.screenSize.m}px) {
    max-width: 60px;
    max-height: 60px;
  }
`;
